import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processSubscribedContact = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_SUBSCRIBED_CONTACT, item)
}

export const updateSubscribedContacts = (store, {reference_type, reference_id, subscribed_contacts}) => {
    return axios.post(`/api/subscribed-contacts`, {
        reference_type,
        reference_id,
        subscribed_contacts
    }).then(res => {
        _.each(
            store.getters.subscribedContactsByReference(reference_type, reference_id),
            item => store.commit(mutations.REMOVE_SUBSCRIBED_CONTACT, item)
        )

        _.each(res.data, item => processSubscribedContact(store, item))

        return res
    })
}
